module.exports = __webpack_public_path__ + "static/media/1q.319e8a5c.svg";